<template>
    <div>

        <!-- Completed -->
        <trax-ui-card-result v-if="completed" :background-color="state.color_status" result-size="md"
            :result="lang.polaris.dashboard.completed">
        </trax-ui-card-result>

        <!-- Incomplete -->
        <trax-ui-card-result v-else-if="!allowed" background-color="default" result-size="md"
            :result="lang.polaris.dashboard.in_progress">
        </trax-ui-card-result>

        <!-- Mark as completed -->
        <trax-ui-card :title="lang.polaris.dashboard.completion" title-bold="1" v-else>

            {{ lang.polaris.dashboard.mark_as_completed_text }}

            <div class="mt-3">
                <button class="btn btn-round btn-danger" @click="sign()">
                    {{ lang.polaris.dashboard.mark_as_completed }}
                </button> 
            </div>

            <!-- Signature modal -->

            <trax-ui-modal-default :id="id+'-sign'" :bus="bus" :title="lang.polaris.dashboard.signature">
                <enac-atpl-dashboard-item-save-sign-popup :id="id+'-sign'" :bus="bus"
                    :text="lang.polaris.dashboard.mark_as_completed_confirm">
                </enac-atpl-dashboard-item-save-sign-popup>
            </trax-ui-modal-default>

        </trax-ui-card>

    </div>
</template>

<script>
    export default {

        props: {
            id: {default: 'enac-atpl-dashboard-mark-completed'}
        },

        data: function() {
            return {
                lang: lang,
                learner: data.learner,
                user: user,
                state: data.state,
                registration: data.registration,
                endpoint: app_url+'polaris/api/front/dashboard/registrations/'+data.registration.id+'/learning-units/'+data.item.id+'/me',
                bus: new Vue()
            }
        },

        computed: {

            completed: function() {
                return this.state.completed;
            },

            // An archived registration is closed: an unfinished unit stays unfinished,
            // so the completion is only reported, never offered anymore.
            editableStatus: function() {
                return this.registration.status != 'archived';
            },

            allowed: function() {
                return this.editableStatus && this.learner.id == this.user.id;
            }
        },

        created: function() {
            this.bus.$on(this.id+'-sign-created', this.signed);
        },

        methods:  {

            sign: function() {
                this.bus.$emit(this.id+'-sign-create');
            },

            signed: function() {
                var that = this;
                axios.post(this.endpoint, {
                    summary: {
                        completed: true,
                        sign: 'learner_validation'
                    }
                })
                .then(function (response) {
                    that.state = response.data.data.summary.data;
                })
                .catch(function (error) {
                });
            }
        }

    }
</script>
